export const JSON_ONE21 = {
   
    
        "header": {
        "ipAddress": "192.168.1.147",
        "userAgent": "Java/1.8.0_73",
        "operatingSystem": "andriod",
        "sessionId": "AGGR001158",
        "version": "1.0.0",
        "date": "Mar 9, 2020 5:36:32 PM",
        "requestId": "e798c61e-85f7-48a0-9ae4-1dd7d75557d9"
        },
        "transaction": {
        "requestType": "WTW",
        "requestSubType": "BENEF",
        "transCode": "389",
        "transAmt": "0.0",
        "userId": "AGGR001158",
        "id": "AGGR001158",
        "uId": "AGGR001158",
        "surChargeAmount": "0.0",
        "txnCode": "o"
        },
        "response": {
        "code": "S0033",
        "description": "Beneficiary Added Successfully with Beneficiary Id BENE001015"
        },
        "payOutBean": {
        "payoutId": "PAYO001074",
        "mobileNo": "7974845996",
        "customerId": "AGGR001158",
        "txnAmount": "1.00",
        "accountNo": "1196****23***56",
        "ifscCode": "ICIC****01196",
        "bankName": "NA",
        "accountHolderName": "ABC",
        "txnType": "IMPS",
        "aggregatorId": "AGGR001158",
        "accountType": "Saving",
        "txnStatus": "success",
        "bankRefNo": "900119955393",
        "spkRefNo": "51601",
        "bankStatus": "SUCCESS",
        "statusCode": "00000",
        "statusDesc": "Success",
        "txnDate": "Mon Mar 09 17:36:19 IST 2020"
        }
        }

export const JSON_TWO22 = {
    
    
        "header": {
        "userAgent": "Mozilla/5.0 Chrome/75.0.3770.142 Safari/537.36",
        "operatingSystem": "WEB",
        "sessionId": "1e2e5448c78d597bb82a36d44ee3faa85",
        "version": "1.0.0",
        "date": "Mar 18, 2020 2:24:46 PM",
        "requestId": "39a0104d-9f1e-47c4-a53e-37daa2bdcd84"
        },
        "transaction": {
        "requestType": "WTW",
        "requestSubType": "PBENE",
        "agId": "AGGR001158",
        "userId": "AGGR001158",
        "id": "AGGR001158"
        },
        "response": {
        "code": "S0026",
        "description": "Wallet To Bank Amount Transfer Successfully, Ref No:PAYO001085"
        },
        "payOutBean": {
        "payoutId": "PAYO001085",
        "mobileNo": "7879455898",
        "customerId": "AGGR001158",
        "txnAmount": "2.00",
        "accountNo": "3511985309",
        "ifscCode": "KKBK0001422",
        "bankName": "NA",
        "accountHolderName": "Rajkumar",
        "txnType": "IMPS",
        "aggregatorId": "AGGR001158",
        "accountType": "NA",
        "txnStatus": "success",
        "bankRefNo": "900119955393",
        "spkRefNo": "20303",
        "bankStatus": "SUCCESS",
        "statusCode": "00000",
        "statusDesc": "Success",
        "txnDate": "Wed Mar 18 14:24:15 IST 2020"
        }
        }

export const JSON_THREE23 = {
    
  
    
        "header": {
        "operatingSystem": "andriod",
        "sessionId": "AGGR001158"
        },
        "transaction": {
        "requestType": "TMH",
        "requestSubType": "STCHK",
        "channel": "WEB",
        "uId": "AGGR001158",
        "userId": "AGGR001158"
        },
        "response": {
        "code": "0000",
        "description": "Successful"
        },
        "payOutBean": {
        "payoutId": "PAYO001229",
        "mobileNo": "9926355663",
        "customerId": "AGGR001158",
        "txnAmount": "2.00",
        "accountNo": "001700000004",
        "ifscCode": "HDFC0229154",
        "bankName": "HDFC",
        "accountHolderName": "Ajay",
        "txnType": "IMPS",
        "aggregatorId": "AGGR001158",
        "accountType": "Savings",
        "txnStatus": "SUCCESS",
        "bankStatus": "Transaction Successful",
        "statusCode": "0000",
        "statusDesc": "Transaction Successful",
        "orderRefNo": "NA"
        }
        }

















    